const isScreenshotMode = false;

export const isMocked = false;

export const blackListedStudypackIdsForWeb: number[] = [];
export const defaultMasteryLabels = {
	low: "Needs work",
	medium: "Almost there",
	high: "Mastered",
	none: "Not answered",
};

export const getBrightcoveVideoUrl = (videoId: number) =>
	`https://players.brightcove.net/2324982687001/PYxPM5GJJ_default/index.html?videoId=${videoId}`;

export { skillIconMap } from "@memorang/ui/constants";
export { isScreenshotMode };
